import React from "react";

interface RangeSliderProps {
  id?: string;
  name: string;
  value: string | number;
  min: number;
  max: number;
  step: number;
  percentage: number;
  onChange: (value: string) => void;
  dataFbInput: string;
}

export const RangeSlider: React.FC<RangeSliderProps> = ({
  id,
  name,
  value,
  min,
  max,
  step,
  percentage,
  onChange,
  dataFbInput
}) => {
  return (
    <span className="range-input">
      <input
        className="form-control"
        style={ { ["--pct" as keyof React.CSSProperties]: `${percentage}%` } }
        id={ id }
        name={ name }
        type="range"
        autoComplete="off"
        data-fb-input={ dataFbInput }
        min={ min }
        max={ max }
        step={ step }
        value={ value || 0 }
        data-value={ value || 0 }
        onChange={ (e) => onChange(e.target.value) }
      />
    </span>
  );
};
